import { Machine } from '../../entities/machine.type';
import { PlaylistItemDTO } from '../playlist-item-models/playlist-item-dto.model';
import { PersonalDataViewModel } from '../account-models/user-models/personal-data-view-model';
import { TransitionEffect } from '../../../constants/transition-effect.const';

export class PlaylistDTO {
    Id: number;
    PlaylistTitle: string;
    PlaylistDescription: string;
    IsActive: boolean;
    IsRepeated: boolean;
    MachinePhysicalAddress: string;
    UserId: string;
    DateCreated: Date;
    PlaylistItems: PlaylistItemDTO[] = [];
    Machine: Machine;
    IsShared: boolean;
    IsSharedWithAllUsers: boolean;
    IsAndroid: boolean;
    CompanyId: number;
    User: PersonalDataViewModel;
    Transition: TransitionEffect
}
